import styles from './Avatar.module.css';

const PALETTE = ['#F2B922', '#2E7D32', '#2F6FED', '#7C3AED', '#0D9488', '#D9724B'];

function hashName(name) {
  let hash = 0;
  for (let i = 0; i < name.length; i += 1) hash = (hash * 31 + name.charCodeAt(i)) >>> 0;
  return hash;
}

function initials(name) {
  const parts = name.trim().split(/\s+/);
  return ((parts[0]?.[0] || '') + (parts[1]?.[0] || '')).toUpperCase();
}

export default function Avatar({ name, size = 36 }) {
  const color = PALETTE[hashName(name || '?') % PALETTE.length];
  return (
    <div
      className={styles.avatar}
      style={{ width: size, height: size, fontSize: size * 0.4, background: `${color}26`, color }}
    >
      {initials(name || '?')}
    </div>
  );
}
